// extracted by mini-css-extract-plugin
export default {"title":"unions_title__rA3Cb"};